import cn from 'classnames';
import SeatMap from './components/SeatMap/SeatMap.css';
import SeatMapControls from './components/SeatMap/Controls/Controls.css';
import Baggage from './components/Baggage/Baggage.css';
import Passengers from './components/Passengers/Passengers.css';
import PassengersPassenger from './components/Passengers/Passenger/Passenger.css';
import Checkout from './components/Checkout/Checkout.css';
import Input from './components/Input/Input.css';
import Checkin from './components/Checkin/Checkin.css';
import SearchFormSegments from './components/SearchForm/Segments/Segments.css';
import SearchFormSegment from './components/SearchForm/Segment/Segment.css';
import SearchFormLocation from './components/SearchForm/Location/Location.css';
import SearchFormValue from './components/SearchForm/Value/Value.css';
import SearchFormDatepicker from './components/SearchForm/Datepicker/Datepicker.css';
import SearchFormControls from './components/SearchForm/Controls/Controls.css';
import SearchFormPassengers from './components/SearchForm/Passengers/Passengers.css';
import SearchFormCurrency from './components/SearchForm/Currency/Currency.css';
import SearchFormStartSearch from './components/SearchForm/StartSearch/StartSearch.css';
import SearchFormBottom from './components/SearchForm/Bottom/Bottom.css';
import SearchFormMultiCity from './components/SearchForm/MultiCity/MultiCity.css';
import LocationDropdown from './components/LocationAutocomplete/Dropdown/Dropdown.css';
import LocationGroup from './components/LocationAutocomplete/Group/Group.css';
import LocationOption from './components/LocationAutocomplete/Option/Option.css';
import DirectionsDialog from './components/LocationAutocomplete/DirectionsDialog/DirectionsDialog.css';
import SearchFormDatepickerMonthHeader from './components/SearchFormDatepicker/MonthHeader/MonthHeader.css';
import SearchFormDatepickerWeeklyHeader from './components/SearchFormDatepicker/WeeklyHeader/WeeklyHeader.css';
import SearchFormDatepickerDay from './components/SearchFormDatepicker/Day/Day.css';
import Results from './components/Results/Results.css';
import ResultsCalendar from './components/Results/Calendar/Calendar.css';
import ResultsSortings from './components/Results/Sortings/Sortings.css';
import ResultsFlightsList from './components/Results/FlightsList/FlightsList.css';
import ResultsMobilePriceGraph from './components/Results/MobilePriceGraph/MobilePriceGraph.css';
import QuickSearchForm from './components/QuickSearchForm/QuickSearchForm.css';
import QuickSearchFormSummary from './components/QuickSearchForm/Summary/Summary.css';
import StepbarStep from './components/Stepbar/Step/Step.css';
import WeekCalendar from './components/WeekCalendar/WeekCalendar.css';
import WeekCalendarSlider from './components/WeekCalendar/Slider/Slider.css';
import WeekCalenderDay from './components/WeekCalendar/Day/Day.css';
import DesktopFlightRoute from './components/DesktopFlightRoute/DesktopFlightRoute.css';
import DesktopFlightRouteSegment from './components/DesktopFlightRoute/Segment/Segment.css';
import DesktopFlightRoutePoint from './components/DesktopFlightRoute/Point/Point.css';
import DesktopFlightRouteArrow from './components/DesktopFlightRoute/RouteArrow/RouteArrow.css';
import DesktopFlightRoutePrice from './components/DesktopFlightRoute/FlightPrice/FlightPrice.css';
import DesktopFlightRouteStopsInfo from './components/DesktopFlightRoute/StopsInfo/StopsInfo.css';
import MobileFlight from './components/MobileFlight/MobileFlight.css';
import DatepickerDay from './components/Datepicker/Day/Day.css';
import Amenities from './components/Amenities/Amenities.css';
import Toolbar from './components/Toolbar/Toolbar.css';
import SwitchV2 from './components/SwitchV2/SwitchV2.css';
import FareGroup from './components/FareGroup/FareGroup.css';
import PromoLoader from './components/PromoLoader/PromoLoader.css';
import PaymentForm from './components/PaymentForm/PaymentForm.css';
import CompareFares from './components/CompareFares/CompareFares.css';
import LoyaltyGroup from './components/PassengerForm/LoyaltyGroup/LoyaltyGroup.css';
import Resend from './components/Contacts/Resend/Resend.css';
import TicketExample from './components/TicketExample/TicketExample.css';
const theme = {
    SeatMap: {
        Passenger: {
            item: SeatMap.passengerItem,
            item_active: SeatMap.passengerItem_selected,
            avatar: SeatMap.avatar,
            clear: SeatMap.clear,
            select: SeatMap.select,
            money: SeatMap.money,
            item_recommend: SeatMap.passengerItem_recommend,
            passengerName: SeatMap.passengerName
        },
        PassengersStyles: {
            recommend: SeatMap.recommend,
            recommend__icon: SeatMap.recommend__icon
        },
        SeatMapDisclaimerStyles: {
            disclaimer: SeatMap.disclaimer
        },
        DoubleSeat: {
            container: SeatMap.doubleSeat,
            switch__label: SeatMap.doubleSeat__label,
            description: SeatMap.doubleSeat__description
        },
        SeatTooltipStyles: {
            popper: SeatMap.popper
        },
        Controls: {
            controls: SeatMapControls.controls,
            back: SeatMapControls.back,
            button: SeatMapControls.button
        }
    },
    Disclaimer: {
        DisclaimerStyles: {
            disclaimer__icon: SeatMap.disclaimer__icon
        }
    },
    BaggagePage: {
        BaggagePage: {
            baggage: Baggage.page
        }
    },
    Switch: {
        SwitchV2: {
            primary: SwitchV2.primary,
            main: SwitchV2.main,
            active: SwitchV2.active
        }
    },
    AdditionalServiceBanner: {
        AdditionalServiceBannerStyles: {
            baggageBanner: Baggage.baggage__banner
        }
    },
    BaggageList: {
        BaggageList: {
            item: Baggage.list__item
        }
    },
    UpgradeBaggageDialog: {
        BaggageDialogHeader: {
            baggage_wrapper: Baggage.list__item,
            perFlight: Baggage.baggage_perFlight
        },
        UpgradeBaggageDialog: {
            close: Baggage.upgradeDialog__close,
            withTabs: Baggage.withTabs
        },
        BaggageSegment: {
            root: Baggage.baggageSegment__root,
            price: Baggage.baggageSegment__price
        },
        BaggagePassenger: {
            name_wrapper: Baggage.name_wrapper,
            counter_wrapper: Baggage.counter_wrapper
        }
    },
    BaggageCounter: {
        BaggageCounter: {
            plus: Baggage.baggage__counter,
            minus: Baggage.baggage__counter
        }
    },
    Passenger: {
        Switch: {
            element: Passengers.switch__item,
            element_active: Passengers.switch__item_active,
            container: Passengers.switch__container,
            element_error: Passengers.switch__item_error,
            error: Passengers.error
        }
    },
    Checkout: {
        CheckoutStyles: {
            container: Checkout.container,
            desktopFlight__flight: Checkout.desktopFlights
        }
    },
    Input: {
        Input: {
            input: Input.input,
            input_standard: Input.input_standard,
            real_input: Input.real_input,
            input_focused: Input.input_focused,
            underline: Input.underline
        }
    },
    SearchForm: {
        Segments: {
            segments: SearchFormSegments.segments,
            segments_multiCity: SearchFormSegments.segments_multiCity
        },
        Segment: {
            cell: cn(SearchFormSegment.cell, SearchFormValue.cell),
            cell_date: SearchFormSegment.cell_date,
            cell_location: SearchFormSegment.cell_location,
            input: SearchFormSegment.input,
            input_focused: SearchFormSegment.input_focused,
            alternative: SearchFormSegment.alternative
        },
        Location: {
            switcher: SearchFormLocation.switcher,
            switcher_highlighted: SearchFormLocation.switcher_highlighted,
            input: SearchFormLocation.input,
            input_withoutPlaceholder: SearchFormLocation.input_withoutPlaceholder,
            switcher_alternative: SearchFormLocation.switcher_alternative
        },
        Value: {
            wrapper: SearchFormValue.wrapper,
            value: SearchFormValue.value,
            code: SearchFormValue.code,
            wrapper_alternative: SearchFormValue.wrapper_alternative
        },
        Datepicker: {
            dates: SearchFormDatepicker.dates,
            dates__to: SearchFormDatepicker.dates__to,
            dates__back: SearchFormDatepicker.dates__back,
            dates_focused: SearchFormDatepicker.dates_focused,
            dates__to_focused: SearchFormDatepicker.dates__to_focused,
            dates__back_focused: SearchFormDatepicker.dates__back_focused,
            dates__to_text: SearchFormDatepicker.dates__to_text,
            placeholder: SearchFormDatepicker.placeholder,
            dow: SearchFormDatepicker.dow,
            alternative: SearchFormDatepicker.alternative,
            alternative_dow: SearchFormDatepicker.alternative_dow,
            highlighted_minPrice: SearchFormDatepicker.highlighted_minPrice
        },
        Controls: {
            controls: SearchFormControls.controls,
            controls_multiCity: SearchFormControls.controls_multiCity
        },
        Passengers: {
            passengers: SearchFormPassengers.passengers,
            selector: SearchFormPassengers.selector,
            arrowIcon: SearchFormPassengers.arrowIcon,
            item: SearchFormPassengers.item,
            passengerType: SearchFormPassengers.passengerType,
            age: SearchFormPassengers.age,
            menu: SearchFormPassengers.menu,
            passengers_isMultiCity: SearchFormPassengers.passengers_isMultiCity
        },
        Currency: {
            currency: SearchFormCurrency.currency,
            selector: SearchFormCurrency.selector,
            arrowIcon: SearchFormCurrency.arrowIcon,
            item: SearchFormCurrency.item,
            dropdown: SearchFormCurrency.dropdown
        },
        StartSearch: {
            startSearch: SearchFormStartSearch.startSearch,
            startSearch_multiCity: SearchFormStartSearch.startSearch_multiCity
        },
        Bottom: {
            bottom: SearchFormBottom.bottom
        },
        MultiCity: {
            multiCity: SearchFormMultiCity.multiCity
        }
    },
    LocationAutocomplete: {
        Dropdown: {
            options: LocationDropdown.options,
            allDirections: LocationDropdown.allDirections,
            allDirections__button: LocationDropdown.allDirections__button
        },
        Group: {
            group: LocationGroup.group,
            group__label: LocationGroup.group__label
        },
        Option: {
            option: LocationOption.option,
            code: LocationOption.code
        },
        DirectionsDialog: {
            paper: DirectionsDialog.paper,
            dialog: DirectionsDialog.dialog,
            label: DirectionsDialog.label,
            countries: DirectionsDialog.countries,
            countries__list: DirectionsDialog.countries__list,
            country: DirectionsDialog.country,
            country_active: DirectionsDialog.country_active,
            cities: DirectionsDialog.cities,
            city: DirectionsDialog.city,
            iata: DirectionsDialog.iata
        }
    },
    Passengers: {
        PassengerStyles: {
            decrease: PassengersPassenger.decrease,
            increase: PassengersPassenger.increase,
            counter: PassengersPassenger.counter,
            counter_disabled: PassengersPassenger.counter_disabled
        }
    },
    SearchFormDatepicker: {
        MonthHeaderStyles: {
            monthHeader: SearchFormDatepickerMonthHeader.monthHeader,
            monthHeader__select_month: SearchFormDatepickerMonthHeader.monthHeader__select_month,
            monthHeader__select_year: SearchFormDatepickerMonthHeader.monthHeader__select_year
        },
        WeeklyHeaderStyles: {
            dayOfWeekName_withPrices: SearchFormDatepickerWeeklyHeader.dayOfWeekName_withPrices
        },
        DayStyles: {
            day_fromOtherMonth: DatepickerDay.day_fromOtherMonth,
            day_withPrice: SearchFormDatepickerDay.day_withPrice,
            day_selected: SearchFormDatepickerDay.day_selected,
            day__price: SearchFormDatepickerDay.day__price,
            day_today: SearchFormDatepickerDay.day_today,
            day_inPeriod: SearchFormDatepickerDay.day_inPeriod,
            day_hasPrice: SearchFormDatepickerDay.day_hasPrice,
            day_weekend: SearchFormDatepickerDay.day_weekend,
            day_startHover_withprice: SearchFormDatepickerDay.day_startHover_withprice,
            day_startHover_withPrice: SearchFormDatepickerDay.day_startHover_withPrice,
            day_endHover_withPrice: SearchFormDatepickerDay.day_endHover_withPrice
        }
    },
    Results: {
        Results: {
            header: Results.header,
            inner: Results.inner,
            toolbar__backButton: Results.toolbar__backButton,
            toolbar__nextButton: Results.toolbar__nextButton
        },
        Calendar: {
            legNumber: ResultsCalendar.legNumber,
            title__text: ResultsCalendar.title__text,
            title__cities: ResultsCalendar.title__cities
        },
        Sortings: {
            title: ResultsSortings.title,
            title_open: ResultsSortings.title_open,
            currentSorting: ResultsSortings.currentSorting,
            flightType: ResultsSortings.flightType,
            flightType__active: ResultsSortings.flightType__active,
            paper: ResultsSortings.paper
        },
        FlightsList: {
            controls__wrapper: ResultsFlightsList.controls__wrapper,
            leg: ResultsFlightsList.leg
        },
        MobilePriceGraph: {
            dates: ResultsMobilePriceGraph.dates
        }
    },
    QuickSearchForm: {
        QuickSearchForm: {
            inner: QuickSearchForm.inner
        },
        Summary: {
            editButtonWrapper: QuickSearchFormSummary.editWrapper,
            summary: QuickSearchFormSummary.summary,
            dates: QuickSearchFormSummary.dates,
            route: QuickSearchFormSummary.route,
            route__icon: QuickSearchFormSummary.route__icon,
            passengers: QuickSearchFormSummary.passengers
        }
    },
    Stepbar: {
        Step: {
            step: StepbarStep.step,
            step_active: StepbarStep.step_active
        }
    },
    WeekCalendar: {
        WeekCalendarStyles: {
            dayWrapper: cn(WeekCalendar.dayWrapper, WeekCalenderDay.dayWrapper)
        },
        SliderStyles: {
            arrow_prev: WeekCalendarSlider.arrow_prev,
            arrow_next: WeekCalendarSlider.arrow_next
        },
        DayStyles: {
            day: WeekCalenderDay.day,
            day_selected: WeekCalenderDay.day_selected,
            day_notAvailable: WeekCalenderDay.day_notAvailable,
            date: WeekCalenderDay.date,
            date__dow: WeekCalenderDay.date__dow,
            date__info: WeekCalenderDay.date__info,
            price__wrapper: WeekCalenderDay.price__wrapper,
            price: WeekCalenderDay.price
        }
    },
    DesktopFlightRoute: {
        DesktopFlightRouteStyles: {
            flight: DesktopFlightRoute.flight
        },
        SegmentStyles: {
            flightInfo__date: DesktopFlightRouteSegment.flightInfo__date,
            flightInfo__airline: DesktopFlightRouteSegment.flightInfo__airline,
            aircraft: DesktopFlightRouteSegment.aircraft,
            segment: DesktopFlightRouteSegment.segment,
            segment_additional: DesktopFlightRouteSegment.segment_additional,
            totalDuration__decorator: DesktopFlightRouteSegment.totalDuration__decorator,
            flightInfo__nextDay: DesktopFlightRouteSegment.flightInfo__nextDay
        },
        PointStyles: {
            time: DesktopFlightRoutePoint.time,
            airport: DesktopFlightRoutePoint.airport,
            point_thin: DesktopFlightRoutePoint.point_thin
        },
        RouteArrowStyles: {
            timeInRoute: DesktopFlightRouteArrow.timeInRoute,
            flightNumber: DesktopFlightRouteArrow.flightNumber
        },
        FlightPriceStyles: {
            price: DesktopFlightRoutePrice.price,
            button: DesktopFlightRoutePrice.button,
            seats: DesktopFlightRoutePrice.seats
        },
        StopsInfoStyles: {
            stop: DesktopFlightRouteStopsInfo.stop
        }
    },
    MobileFlight: {
        FlightStyles: {
            price: MobileFlight.price
        }
    },
    Datepicker: {
        DayStyles: {
            day_notAvailable: DatepickerDay.day_notAvailable
        }
    },
    Amenities: {
        Amenities: {
            amenities__item: Amenities.amenities__item
        }
    },
    Toolbar: {
        Toolbar: {
            toolbar: Toolbar.toolbar,
            inner: Toolbar.inner,
            actions: Toolbar.actions
        }
    },
    Segment: {
        SegmentCommon: {
            wrapper: Checkin.segmentCommon__wrapper,
            header: Checkin.segmentCommon__header,
            city__airport: Checkin.segmentCommon__cityAirport,
            city__iata: Checkin.segmentCommon__cityIata,
            city__time: Checkin.segmentCommon__cityTime,
            plane__icon: Checkin.segmentCommon__planeIcon,
            flightInfo__title: Checkin.segmentCommon__flightInfoTitle,
            flightInfo__value: Checkin.segmentCommon__flightInfoValue,
            flightInfo__flightItem: Checkin.segmentCommon__flightInfoFlightItem,
            flightInfo: Checkin.segmentCommon__flightInfo
        }
    },
    AddPassenger: {
        AddPassenger: {
            wrapper: Checkin.addPassenger__wrapper,
            passengerIcon: Checkin.addPassenger__passengerIcon,
            form__input: Checkin.addPassenger__formInput
        }
    },
    Checkin: {
        VisaForm: {
            header: Checkin.visaForm__header
        },
        Passengers: {
            segments: Checkin.checkinPassengers__segments
        },
        Hint: {
            image: Checkin.hint__image
        }
    },
    StatusMessage: {
        StatusMessage: {
            statusMessage: Checkin.statusMessage,
            statusMessage_success: Checkin.statusMessage_success
        }
    },
    RegisteredPassenger: {
        RegisteredPassenger: {
            header: Checkin.registeredPassenger__header,
            seats__icon: Checkin.registeredPassenger__seatsIcon
        }
    },
    MobileSegment: {
        MobileSegment: {
            wrapper: Checkin.mobileSegment__wrapper
        }
    },
    FareGroup: {
        FareGroupGrid: {
            option: FareGroup.option,
            paid: FareGroup.paid,
            not_available: FareGroup.notAvailable,
            icon: FareGroup.icon,
            availabilityIcon: FareGroup.availabilityIcon,
            container: FareGroup.container,
            title: FareGroup.title
        },
        FareGroup: {
            option__title: FareGroup.fareOption__title,
            upgradeOptionWrapper: FareGroup.upgradeOptionWrapper
        }
    },
    PromoLoader: {
        PromoLoader: {
            promo: PromoLoader.promo,
            promo__image: PromoLoader.promo__image
        }
    },
    PaymentForm: {
        PaymentForm: {
            cards_header: PaymentForm.cards_header
        }
    },
    CompareFares: {
        CompareFares: {
            fareHeadingItem__serviceClass: CompareFares.fareHeadingItem__serviceClass
        }
    },
    PassengerForm: {
        LoyaltyGroup: {
            container_loyalty: LoyaltyGroup.container_loyalty
        }
    },
    Contacts: {
        ResendStyles: {
            item: Resend.item
        }
    },
    Baggage: {
        BaggageIcon: {
            size: Baggage.baggageIcon__size,
            carry_on: Baggage.baggageIcon__carryOn,
            large: Baggage.baggageIcon__large,
            root: Baggage.baggageIcon__root
        }
    },
    TicketExample: {
        TicketExample: {
            ticketExample: TicketExample.ticketExample
        }
    }
};
export default theme;
